import { SwitchParams } from "../OverviewPopper/type";
import { useStoreState } from "../store/useStore";
import useFetch from "../../hooks/useFetch";

export type tokenParamsState = {
  lang: string;
};

type getUserGrayParams = {
  type: 1 | 2; // 1: 统一账户, 2: 子母账户
};

const useAction = (base?: string) => {
  const { baseUrl } = useStoreState();

  const { post } = useFetch(base ? base : baseUrl);

  const LangUpdate = async <T>(params: tokenParamsState) => {
    return post<T>(`uapi/v1/uc/user/lang/update`, { ...params });
  };

  const getSubAccountLists = async <T>(params = {}) => {
    return post<T>(`uapi/v1/uc/sub/account/list`, { ...params });
  };

  const getToken = async <T>(params: SwitchParams, options?: RequestInit) => {
    return post<T>(`uapi/v1/uc/sub/account/switch`, { ...params }, options);
  };

  const getCopyTradeUserInfo = async <T>(options?: RequestInit) => {
    return post<T>(`uapi/v1/copy_trading/user/info`, {}, options);
  };

  const getUserGray = async <T>(params: getUserGrayParams) => {
    return post<T>(`uapi/v1/uc/gray/user`, { ...params });
  };

  return {
    LangUpdate,
    getSubAccountLists,
    getToken,
    getCopyTradeUserInfo,
    getUserGray
  };
};

export default useAction;
